import { IconButton, styled, type SxProps } from '@mui/material'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
const StyledButton = styled(IconButton)`
    border: 1px solid black;
    padding:4px;
    height:40px;
    width:40px;
    .MuiSvgIcon-root{
      height:30px;
      width:30px; 
      color:black;
    }
`

export interface ActionButtonProps {
  onClick: () => void
  testId?: string
  buttonSx?: SxProps
}

export function ActionButton (props: ActionButtonProps): JSX.Element {
  return <StyledButton sx={{ ...props.buttonSx }} data-testid={props.testId} onClick={props.onClick}><MoreHorizIcon /></StyledButton>
}
